import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { AbcCoreModule } from '@barthauer/abc/core';
import { AbcUiComponentsModule, _AbcButtonComponent, _AbcDrawerComponent } from '@barthauer/abc/ui-components';
import { AbcCoreAuthenticationModule } from '@barthauer/basys/core/authentication';
import {
  DxButtonModule,
  DxContextMenuModule,
  DxGalleryModule,
  DxToolbarModule,
  DxTreeViewModule,
} from 'devextreme-angular';
import { LoginComponent } from './authentication/login/login.component';
import { ProfileSelectionComponent } from './authentication/profile-selection/profile-selection.component';
import { WebApiEditorComponent } from './authentication/webapi-editor/webapi-editor.component';
import { CustomArenaComponent } from './custom-arena.component';
import { DataService } from './services/data.service';
import { ScreenService } from './services/screen.service';
import { ValidationService } from './services/validation.service';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    DxButtonModule,
    DxContextMenuModule,
    DxToolbarModule,
    DxTreeViewModule,
    MatIconModule,
    _AbcDrawerComponent,
    AbcCoreAuthenticationModule,
    AbcCoreModule,
    AbcUiComponentsModule,
    DxGalleryModule,
    _AbcButtonComponent,
  ],
  declarations: [CustomArenaComponent, LoginComponent, ProfileSelectionComponent, WebApiEditorComponent],
  exports: [CustomArenaComponent, LoginComponent, ProfileSelectionComponent, WebApiEditorComponent],
  providers: [ScreenService, DataService, ValidationService],
})
export class CustomArenaModule {}
